<app-header [id]="id"></app-header>

<div class="container mx-auto px-5 lg:px-10 py-8">
  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[400px]">
      <p-progress-spinner ariaLabel="loading tickets" />
    </div>
  } @else if (errorMessage()) {
    <div class="flex items-center justify-center min-h-[400px]">
      <p class="text-lg text-center" role="alert">{{ errorMessage() }}</p>
    </div>
  } @else if (iframeUrl) {
    <iframe
      #fsIframe
      [src]="iframeUrl"
      style="height: 600px"
      title="Tickets"
      scrolling="no"
      class="fs-embed">
    </iframe>
  }
</div>

<app-footer></app-footer>
